import React, { useEffect, useState } from 'react';
import CanvasJSReact from '../../../assets/canvasjs.react';
import { getPerfectTime, getPerfectDateTimeWithHours, convertTimezone } from '../../../utils';
import { useTranslation } from 'react-i18next';

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const ChartPhaseDay = ({data}) =>  {
  const {t} = useTranslation(['widgets']);
  const [loading, setLoading] = useState(true);
  const [chartDataPh1, setChartDataPh1] = useState([]);
  const [chartDataPh2, setChartDataPh2] = useState([]);
  const [chartDataPh3, setChartDataPh3] = useState([]);

  useEffect(() => {
    if (!data) {
      return;
    }
    const itemData1 = [];
    const itemData2 = [];
    const itemData3 = [];

    data.ph1.forEach(it => {
      itemData1.push({
        x: new Date(it.at + convertTimezone(it.at)),
        y: it.v ? (it.v > 0 ? it.v : 0) : 0  
      })
    });

    data.ph2.forEach(it => {
      itemData2.push({
        x: new Date(it.at + convertTimezone(it.at)),
        y: it.v ? (it.v > 0 ? it.v : 0) : 0  
      })
    });

    data.ph3.forEach(it => {
      itemData3.push({
        x: new Date(it.at + convertTimezone(it.at)),
        y: it.v ? (it.v > 0 ? it.v : 0) : 0  
      })
    });

    setChartDataPh1(itemData1);
    setChartDataPh2(itemData2);
    setChartDataPh3(itemData3);
    
    setLoading(false);
  }, [data]);

  const baseOptions = {
    animationEnabled: true,
    zoomEnabled: true,
    height: 100,
    culture:  "ru",
    // toolTip: {
		// 	shared: true,
		// 	contentFormatter: function (e) {
		// 		var content = " ";
		// 		for (var i = 0; i < e.entries.length; i++) {
    //       content += getPerfectDateTime(e.entries[i].dataPoint.x);
    //       content += "<br/>";
		// 			content += e.entries[i].dataSeries.name + " " + "<strong>" + e.entries[i].dataPoint.y + "</strong>";
		// 		}
		// 		return content;
		// 	}
		// },
    toolTip: {
			shared: true,
      fontFamily: "helvetica, arial",
      cornerRadius: 2,
      borderThickness: 0,
			contentFormatter: function (e) {
				var content = " ";
				for (var i = 0; i < e.entries.length; i++) {
          content += "<div class='p-2'>";
          content += getPerfectTime(e.entries[i].dataPoint.x);
          content += "<br/>";
					content += e.entries[i].dataSeries.name + " " + "<strong>" + (e.entries[i].dataPoint.y / 1000).toFixed(2) + "</strong>";
          content += "</div>";
				}
				return content;
			}
		},
    axisX:{
      lineColor: '#E7ECF8',
      intervalType: "hours",
      valueFormatString: 'HH:mm',
      labelFontFamily: "helvetica, arial",
      labelFontColor: '#444444',
      labelFontSize: 10,
    },
    axisY: {
      includeZero: true,
      lineColor: 'transparent',
      gridDashType: 'dash',
      gridColor: '#E7ECF8',
      labelFontFamily: "helvetica, arial",
      labelFontColor: '#444444',
      labelFontSize: 10,
      labelPlacement:"inside",
    },
  };



  const options = {
    data: [
      {
      xValueFormatString: "HH:mm",
      name: t("ph1"),
      type: "column",
      color: '#3066BE',
      fillOpacity: .5,
      lineColor: '#3066BE',
      lineThickness: 1,
      markerType: "circle",
      markerSize: 0,
      dataPoints: chartDataPh1
    },
    {
      xValueFormatString: "HH:mm",
      name: t("ph2"),
      type: "column",
      color: '#60AFFF',
      fillOpacity: .5,
      lineColor: '#60AFFF',
      lineThickness: 1,
      markerType: "circle",
      markerSize: 0,
      dataPoints: chartDataPh2
    },
    {
      xValueFormatString: "HH:mm",
      name: t("ph3"),
      type: "column",
      color: '#28C2FF',
      fillOpacity: .5,
      lineColor: '#28C2FF',
      lineThickness: 1,
      markerType: "circle",
      markerSize: 0,
      dataPoints: chartDataPh3
    }
    ]
  };


  return (
    <div className="my-4 border-t">
      <div className="flex items-center h-10">
        <span>{t('phase_distribution')}</span>
      </div>
      <div className="text-sm">
        <CanvasJSChart options = {{...baseOptions, ...options}}/>
      </div>
    </div>
  );
}

export default ChartPhaseDay;